// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from 'react-redux'
import { store } from './store'
// 1) Grab your root container:
const container = document.getElementById("root");

// 2) Create a root:
const root = createRoot(container);

// 3) Render your app tree
root.render(
  <Provider store={store}>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  </Provider>,
);
